import { FontEntry } from '../../types/font'

export const neueHaasGroteskText: FontEntry = {
  displayName: 'neue-haas-grotesk-text',
  weights: {
    400: {
      normal: { file: 'NHaasGroteskTXPro-55Rg', extension: 'otf', format: 'opentype' },
      italic: { file: 'NHaasGroteskTXPro-56It', extension: 'otf', format: 'opentype' }
    },
    700: {
      normal: { file: 'NHaasGroteskTXPro-75Bd', extension: 'otf', format: 'opentype' },
      italic: null
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 103.57,
        ascentOverride: 94.43,
        descentOverride: 23.65,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 101.33,
        ascentOverride: 98.4,
        descentOverride: 25.96,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 105.09,
        ascentOverride: 93.06,
        descentOverride: 23.31,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 107.35,
        ascentOverride: 92.88,
        descentOverride: 24.5,
        lineGapOverride: 0
      }
    }
  }
}
